import { useMutation } from "@apollo/client";

import { parseDateToString } from "~/modules/app/util/dateHelpers";

import { ProjectReviewVisitV2Screen_UpdateWorkerReportDocument } from "../../../mutations.generated";
import { TimeReportValues } from "../components/TimeReportTableRow";
import { ProjectReviewVisitV2TimeReportsRoute_GetDataDocument } from "../queries.generated";

export function useProjectReviewVisitV2TimeReportsRoute_UpdateStartEndTimes() {
    const [mutate, { loading, error }] = useMutation(ProjectReviewVisitV2Screen_UpdateWorkerReportDocument, {
        refetchQueries: [ProjectReviewVisitV2TimeReportsRoute_GetDataDocument],
    });

    const updateStartEndTimes = (plannerVisitWorkerReportId: string, input: TimeReportValues) => {
        mutate({
            variables: {
                input: {
                    plannerVisitWorkerReportId,
                    startedAt: input.startedAt ? parseDateToString(input.startedAt) : null,
                    stoppedAt: input.stoppedAt ? parseDateToString(input.stoppedAt) : null,
                },
            },
        });
    };

    return {
        updateStartEndTimes,
        loading,
        error,
    };
}
